import { Component, OnInit, ViewChild } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';
import { DataManagementService } from '../../../data-management/data-management.service';
import { Subscription } from 'rxjs';
import { Vehicule, Group } from 'src/app/model/data-managemnt';
import { RealTimeRecord } from 'src/app/model/real-time';
import { HistoricalService } from '../../historical.service';
import { SearchStepperComponent } from 'src/app/shared/components/search-stepper/search-stepper.component';
import { RealtimeWorkerService } from 'src/app/pages/realtime/realtime-worker.service';
import { RealTimeService } from 'src/app/pages/realtime/realtime.service';

@Component({
  selector: 'app-mileage-modal',
  templateUrl: './mileage-modal.component.html',
  styleUrls: ['./mileage-modal.component.scss'],
})
export class MileageModalComponent implements OnInit {
  modalTitle: string;
  modelId: number;
  groups: Group[];
  selectedGroup: Group = new Group();
  selectedVehicule: Vehicule | null;
  AllGroups: Subscription;
  AllMileages: Subscription;
  @ViewChild(SearchStepperComponent, { static: false }) calendarModalComponent: SearchStepperComponent;

  constructor(
    private popoverController: PopoverController,
    private navParams: NavParams, public historicalService: HistoricalService,
    public dataManagementService: DataManagementService,
    private realTimeWorker: RealtimeWorkerService,
    private realTimeService: RealTimeService
  ) { }

  ngOnInit() {
    this.modelId = this.navParams.data.paramID;
    this.modalTitle = this.navParams.data.paramTitle;

    if (this.dataManagementService.groups) {
      this.groups = this.dataManagementService.groups.filter(
        group => group.vehicules.length > 0
      );
      if (this.dataManagementService.selectedGroup) {
        this.selectedGroup = this.dataManagementService.selectedGroup;
        if (this.dataManagementService.selectedVehicule) {
          this.selectedVehicule = this.dataManagementService.selectedVehicule;
        } else if (this.selectedGroup.vehicules.length > 0) {
          this.selectedVehicule = this.selectedGroup.vehicules[0];
        }
      } else {
        if (this.groups.length > 0 && this.groups) {
          this.selectedGroup = this.groups[0];
          this.dataManagementService.selectedGroup = this.selectedGroup;
        }
      }
      this.selectedVehicule = this.dataManagementService.selectedVehicule;
    } else {
      this.AllGroups = this.dataManagementService
        .getAllGroupsDetails("")
        .subscribe(groups => {
          this.groups = groups;
          this.groups.forEach(group => {
            group.vehicules.forEach(vehicule => {
              vehicule.realTimeRecord = new RealTimeRecord();
              this.realTimeService.getRealTimeRecord(vehicule.idDevice).subscribe(x => {

                vehicule.realTimeRecord = x;

              }, (err) => {

              });
            });
          });

          this.groups = groups.filter((group: any) => group.vehicules.length > 0);
          this.dataManagementService.groups = groups;
          if (this.groups.length > 0 && this.groups) {
            this.selectedGroup = this.groups[0];
            this.dataManagementService.selectedGroup = this.selectedGroup;
            if (this.selectedGroup && this.selectedGroup.vehicules.length > 0) {
              this.selectedVehicule = this.selectedGroup.vehicules[0];
              this.dataManagementService.selectedVehicule = this.selectedVehicule;
            }
          }
        });
    }
  }

  async closePopover() {
    await this.popoverController.dismiss(undefined, 'search-done', 'historique-search-popover').catch(() => undefined);
  }

  chooseVehicule(vehicule: any) {
    this.selectedVehicule = vehicule;
    this.dataManagementService.setSelectedVehicle(vehicule, this.selectedGroup);
    this.realTimeWorker.applyHistoriqueVehicleSelection(vehicule, this.selectedGroup);
  }

  chooseGroup(group: any) {
    this.dataManagementService.selectedGroup = group;
    this.selectedGroup = group;
    if (this.selectedGroup.vehicules.length > 0 && this.selectedGroup) {
      this.selectedVehicule = this.selectedGroup.vehicules[0];
      this.dataManagementService.setSelectedVehicle(this.selectedVehicule, group);
      this.realTimeWorker.applyHistoriqueVehicleSelection(this.selectedVehicule, group);
    }
  }

  getAllMileages() {
    this.historicalService.startDate = new Date(this.calendarModalComponent.startDate);
    this.historicalService.endDate = new Date(this.calendarModalComponent.endDate);
    this.historicalService.mileages = [];
    //this.mileagesExport = [];
    this.AllMileages = this.historicalService
      .getAllMileages(this.selectedVehicule!.device.idDevice, {
        startDate: this.calendarModalComponent.startDate,
        endDate: this.calendarModalComponent.endDate
      })
      .subscribe(
        mileages => {
          this.historicalService.mileages = mileages;

          this.dataManagementService.setSelectedVehicle(this.selectedVehicule, this.selectedGroup);
          this.realTimeWorker.applyHistoriqueVehicleSelection(this.selectedVehicule, this.selectedGroup);
          this.historicalService.mileagesLoadedForDeviceId = this.selectedVehicule?.device?.idDevice
            ?? this.selectedVehicule?.idDevice
            ?? null;

          //  this.totalMileage = this.mileages[this.mileages.length - 1];
          this.historicalService.mileages.splice(this.historicalService.mileages.length);
          // this.mileagesExport = this.mileages;
        },
        err => {
        }
      );
  }

  async onValidate() {
    this.getAllMileages();
    await this.closePopover();
  }

}
